import { useEffect, useRef, useState } from "react";

/** Hook mínimo de dado assíncrono: dispara `fn` a cada mudança de `deps`,
    ignora respostas de chamadas já obsoletas (evita "flash" de dado antigo
    quando o aluno/turma troca antes da resposta anterior chegar). */
export function useAsync(fn, deps) {
  const [estado, setEstado] = useState({
    data: null,
    loading: true,
    error: null
  });
  const idAtual = useRef(0);

  useEffect(() => {
    const id = ++idAtual.current;
    setEstado(prev => ({ ...prev, loading: true, error: null }));

    fn()
      .then(data => {
        if (idAtual.current === id)
          setEstado({ data, loading: false, error: null });
      })
      .catch(err => {
        if (idAtual.current === id) {
          setEstado({
            data: null,
            loading: false,
            error: err?.message || "Não foi possível carregar os dados."
          });
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return estado;
}
